import { Injectable } from '@angular/core';
import Swal, { SweetAlertIcon, SweetAlertOptions } from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class PopupService {
  // error toast message
  toastMessage(icon: SweetAlertIcon, text: string, timerCount: number = 10000) {
    let backgroundClass;
    let cancelButtonColor;
    switch (icon) {
      case 'error':
        backgroundClass = 'bg-danger';
        cancelButtonColor = '#a50808';
        break;
      case 'success':
        backgroundClass = 'bg-green';
        cancelButtonColor = '#152d05';
        break;
      case 'info':
        backgroundClass = 'bg-info';
        cancelButtonColor = '#0a1767';
        break;
      case 'warning':
        backgroundClass = 'bg-warning';
        cancelButtonColor = '#79510b';
        break;
      default:
        backgroundClass = 'bg-gray-medium';
        cancelButtonColor = '';
    }

    const options: SweetAlertOptions = {
      position: 'top-end',
      toast: true,
      timer: timerCount,
      timerProgressBar: true,
      showConfirmButton: false,
      showCancelButton: (text !== '' && text !== undefined) ? true : false,
      cancelButtonText: 'Close',
      cancelButtonColor: cancelButtonColor,
      iconColor: '#fff',
      icon: icon,
      text: text,
      backdrop: false,
      customClass: {
        popup: 'd-flex p-2 align-items-center rounded-sm ' + backgroundClass,
        htmlContainer: 'font-size-sm font-weight-light text-white',
        cancelButton: '' // to change the color of cancel button
      },
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      }
    };
    return Swal.fire(options);
  }

  // message popup
  popupMessage(
    icon: string,
    text: string,
    titleText?: string,
    confirmBtnTxt?: string,
    cancelBtnTxt?: string,
    showCancelButton?: boolean,
  ) {
    const options: SweetAlertOptions = {
      iconHtml:
        '<img alt="image"src="./assets/img/icons/' +
        icon +
        '.svg" alt="' +
        icon +
        '" class="w-100 h-100">',
      titleText: titleText,
      text: text,
      showDenyButton: false,
      showCancelButton: showCancelButton,
      confirmButtonText: confirmBtnTxt ?? 'Okay',
      denyButtonText: 'Deny',
      cancelButtonText: cancelBtnTxt,
      buttonsStyling: false,
      backdrop: 'rgba(0, 0, 0, 0.81)',
      allowOutsideClick: false,
      customClass: {
        icon: 'border-0 wx-180 htx-140 my-0',
        popup: 'rounded-lg bg-dark p-6',
        title: 'fs-5 mb-2 text-white p-0',
        htmlContainer: 'my-0 fs-7 mb-3 text-white',
        actions: 'w-100',
        confirmButton: 'btn btn-md  border-0 text-white bg-gray-dark w-100',
        denyButton: 'btn btn-danger border-0 me-4',
        cancelButton: 'btn btn-cancel border-0',
      },
    };
    return Swal.fire(options);
  }

  // info popup
  popupInfo(
    icon: SweetAlertIcon,
    text: string,
    titleText?: string,
    confirmBtnTxt?: string,
  ) {
    const options: SweetAlertOptions = {
      iconHtml:
        '<img alt="image"src="./assets/img/icons/' +
        icon +
        '.svg" alt="' +
        icon +
        '">',
      titleText: titleText,
      text: text,
      showDenyButton: false,
      showCancelButton: false,
      confirmButtonText: confirmBtnTxt ?? 'Okay',
      buttonsStyling: false,
      customClass: {
        icon: 'border-0',
        popup: 'rounded-lg bg-white  pb-6',
        title: 'font-size-lg',
        htmlContainer: 'font-weight-light font-size-md',
        confirmButton:
          'btn btn-sm btn-lighter border-0 w-50 mb-2 py-2 fs-7 text-dark',
        actions: 'w-100',
      },
    };
    return Swal.fire(options);
  }
}
